import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
const path = "/blender/landscapeblend.glb";
const loader = new GLTFLoader();
import { Colors } from "./colors.js";
// Simple solid white material to avoid texture loading
const grassMaterial = new THREE.MeshStandardMaterial({
  color: Colors.green,
  roughness: 0.9,
  metalness: 0,
  side: THREE.DoubleSide,
});
let ground;
let mountains = {};
loader.load(path, (gltf) => {
  gltf.scene.scale.set(1.5);
  gltf.scene.traverse((obj) => {
    if (!obj.isMesh) return;
    if (obj.name == "ground") {
      ground = obj.clone(true);
    } else {
      mountains[obj.name] = obj.clone(true);
    }
  });
});

export class Landscape extends THREE.Object3D {
  constructor(loop, octaveNum) {
    super();
    this.octaveNum = octaveNum;

    this.loop = loop;
    this.anchor = null;
    this.mountainMesh = null;
    this.ready = new Promise((resolve) => {
      const wait = setInterval(() => {
        const ready = ground && Object.keys(mountains).length > 0;
        if (!ready) return;

        if (ground) {
          const g = ground.clone(true);
          g.material = grassMaterial.clone(true);
          this.add(g);
        }

        const src = mountains[this.octaveNum];
        if (src) {
          const mtn = src.clone(true);
          mtn.material = grassMaterial.clone(true);
          this.add(mtn);
          this.mountainMesh = mtn;

          const box = new THREE.Box3().setFromObject(mtn);
          const center = new THREE.Vector3();
          // const boxHelper = new THREE.BoxHelper(mtn, 0xff0000);
          // this.add(boxHelper);
          box.getCenter(center);
          this.anchor = center;
          this.anchor.y = center.y;
        }

        clearInterval(wait);
        resolve();
      }, 16);
    });
    if (this.loop && this.loop.updatables) {
      this.loop.updatables.push(this);
    } else {
      console.warn("Landscape: loop missing; skipping tick registration");
    }
  }
}
